// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2PO2Q","label":"Completed_label__1Thqf"};